import { personEntityData } from '@in-life/constants';

import { personEntity } from '@tracking/trackingEvents';

const getPersonEntityData = () =>
  personEntity({ id: personEntityData.personId });

export { getPersonEntityData };
